import { Dispatch } from "@reduxjs/toolkit";
import { setBMSR, toggleRider } from "../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice";
import { addRiderSalaryRankInput } from "../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.slice";
import { PROPOSAL_RIDERS } from "../../constant/gms-constant";
import { Riders } from "../../api/gms/proposal/proposal-api-state";
import { pa_addRiderSalaryRankInput, pa_setBMSR, pa_toggleRider } from "../../features/propose-data/propose-data-slice";

export const populateRidersSalaryRank = (dispatch: Dispatch, riders: Riders[], type: "current" | "proposed", optionForGroupDengueRider?: { id: number; fAmount: number; label: string }[]) => {
    riders.forEach((rider) => {
        const riderData = { id: rider.rider_id, label: rider.rider_name };

        if (type === "current") {
            dispatch(toggleRider(riderData));
        }
        // if (type === "proposed") dispatch(pa_toggleRider(riderData));
    });

    riders.forEach((rider) => {
        const riderData = { 
            id: rider.rider_id, 
            label: rider.rider_name, 
            values: rider.values, 
            type: "api" as const 
        };

        if (type === "current") {
            dispatch(addRiderSalaryRankInput(riderData));
        }
        if (type === "proposed") {
            dispatch(pa_addRiderSalaryRankInput(riderData));
        }
    });

    const riderMap: Record<string, number[]> = {
        BMSR: [
            PROPOSAL_RIDERS.BMSR.productFor.GYRT,
            PROPOSAL_RIDERS.BMSR.productFor.GCI,
        ],
    };

    const riderBMSR = riders.find((rider) => riderMap.BMSR.some((id) => id === rider.rider_id));

    const bmsrData = {
        id: riderBMSR?.rider_id ?? 0,
        label: riderBMSR?.rider_name ?? "",
        inputs: [{ fAmount: riderBMSR?.values?.[0]?.amount ?? 0 }],
    };

    if (type === "current") {
        dispatch(setBMSR(bmsrData));
    }
    if (type === "proposed") {
        dispatch(pa_setBMSR(bmsrData));
    }
};